// Web implementation of keyboard shortcut handling.
import { useEffect, useRef } from 'react';

type KeyboardShortcut = {
    id: number;
    key: string;
    callback: (e: KeyboardEvent) => void;
    index: number;
};

let registeredKeyboardShortcuts: KeyboardShortcut[] = [];

export function useKeyboardShortcut({ shortcutKey, callback, index = 0 }: { shortcutKey: string; callback: any; index?: number }) {
    const idRef = useRef<number | null>(null);

    useEffect(() => {
        const maxId = registeredKeyboardShortcuts.length > 0 ? Math.max(...registeredKeyboardShortcuts.map((shortcut) => shortcut.id)) : 0;
        const id = maxId + 1;
        idRef.current = id;
        registeredKeyboardShortcuts.push({ id, key: shortcutKey, callback, index });

        return () => {
            registeredKeyboardShortcuts = registeredKeyboardShortcuts.filter((shortcut) => shortcut.id !== id);
        };
    }, [shortcutKey, callback, index]);

    return idRef.current;
}

export function KeyboardShortcutHandler() {
    const keyboardHandler = (e: any) => {
        let filteredShortcutsForKey = registeredKeyboardShortcuts.filter((shortcut) => shortcut.key === e.key);
        if (filteredShortcutsForKey.length === 0) {
            return;
        }
        const maxIndex = Math.max(...filteredShortcutsForKey.map((shortcut) => shortcut.index));
        filteredShortcutsForKey = filteredShortcutsForKey.filter((shortcut) => shortcut.index === maxIndex);
        if (filteredShortcutsForKey.length > 0) {
            filteredShortcutsForKey.forEach((shortcut) => shortcut.callback(e));
        }
    };
    useEffect(() => {
        window.addEventListener('keydown', keyboardHandler);
        return () => window.removeEventListener('keydown', keyboardHandler);
    }, []);

    return <></>;
}
